// extracted by mini-css-extract-plugin
export var closeButton = "_hl-2";
export var closeButtonIcon = "_hl-3";
export var lightboxContent = "_hl-1";
export var lightboxOverlay = "_hl-0";